export default {
  'profile.tabBookings': 'Đặt tour của tôi',
  'profile.tabSaved': 'Tour đã lưu',
  'profile.tabSettings': 'Cài đặt tài khoản',
  'profile.traveler': 'Du khách',
  'profile.signingOut': 'Đang đăng xuất...',
  'profile.signOut': 'Đăng xuất',
  'profile.loadingBookings': 'Đang tải đặt tour...',
  'profile.somethingWrong': 'Đã xảy ra lỗi',
  'profile.tryAgain': 'Thử lại',
  'profile.noBookings': 'Chưa có đặt tour nào',
  'profile.noBookingsText': 'Khám phá các tour và bắt đầu lên kế hoạch cho chuyến phiêu lưu Việt Nam của bạn.',
  'profile.exploreTours': 'Khám phá tour',
  'profile.bookingCode': 'Mã đặt tour',
  'profile.guest': 'khách',
  'profile.guests': 'khách',
  'profile.total': 'Tổng cộng',
  'profile.noSaved': 'Chưa có tour đã lưu',
  'profile.noSavedText': 'Chạm vào biểu tượng trái tim trên bất kỳ tour nào để lưu vào đây để xem sau.',
  'profile.viewTour': 'Xem tour',
  'profile.removeTour': 'Bỏ {{title}}',
  'profile.personalInfo': 'Thông tin cá nhân',
  'profile.updateName': 'Cập nhật tên và thông tin liên hệ của bạn.',
  'profile.fullName': 'Họ và tên',
  'profile.emailAddress': 'Địa chỉ email',
  'profile.emailNote': 'Email của bạn được dùng để đăng nhập và không thể thay đổi tại đây.',
  'profile.saving': 'Đang lưu...',
  'profile.saveChanges': 'Lưu thay đổi',
  'profile.changePassword': 'Đổi mật khẩu',
  'profile.keepSecure': 'Giữ tài khoản an toàn bằng cách cập nhật mật khẩu thường xuyên.',
  'profile.currentPassword': 'Mật khẩu hiện tại',
  'profile.newPassword': 'Mật khẩu mới',
  'profile.confirmNewPassword': 'Xác nhận mật khẩu mới',
  'profile.min6': 'Tối thiểu 6 ký tự',
  'profile.reenterNew': 'Nhập lại mật khẩu mới',
  'profile.updated': 'Hồ sơ của bạn đã được cập nhật.',
  'profile.passwordUpdated': 'Mật khẩu của bạn đã được cập nhật thành công.',
  'profile.enterCurrent': 'Vui lòng nhập mật khẩu hiện tại.',
  'profile.newMin6': 'Mật khẩu mới phải có ít nhất 6 ký tự.',
  'profile.newMismatch': 'Mật khẩu mới không khớp.',
  'profile.currentIncorrect': 'Mật khẩu hiện tại của bạn không đúng.',
  'profile.updateFailed': 'Không thể cập nhật mật khẩu. Vui lòng thử lại.',
  'profile.updating': 'Đang cập nhật...',
  'profile.updatePassword': 'Cập nhật mật khẩu',
  'profile.hidePassword': 'Ẩn mật khẩu',
  'profile.showPassword': 'Hiện mật khẩu',
};